/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Ai2Playground = ({ color = 'primary', aspectRatio = '1485/173', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Ai2Playground" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Ai2Playground, Ai2Playground as default };
